import { TeamsUserCredential } from "@microsoft/teamsfx";
import React from "react"
import { NewGraph } from "./NewGraph";
import { useData } from "../lib/useData";
import { useTeamsFx } from "../lib/useTeamsFx";
import New from "./New";

export default function Welcome() {
    const [userData, setUserData] = React.useState({
        organization: { id: "" },
        profile: { displayName: "", mail: "" },
        photoUrl: "",
        loaded: false
    });

    const updateUserData = (userData: any) => {
        console.log(userData);
        setUserData({...userData, loaded: true });
    };
    
    const { isInTeams } = useTeamsFx();
    
    const userProfile = useData(async () => {
        const credential = new TeamsUserCredential();
        return isInTeams ? await credential.getUserInfo() : undefined;
    })?.data;

    const userName = userProfile ? userProfile.displayName : "";

    return (
        <>
        {!userData.loaded && (
            <NewGraph updateUserData={updateUserData} />
        )}
        {userData.loaded && (
            <New userData={userData} />
        )}
            
        </>
    )
}
